module.exports = __webpack_public_path__ + "static/media/Favcon.d9bc5e84.png";